import { useEffect, useState } from 'react';
import { useDispatch } from 'react-redux';
import { db } from '../../../../firebase';
import { collection, onSnapshot } from 'firebase/firestore';
import { templatesLoadedAction } from '../../../actions/preloaded';
import { dataCompletedAction } from '../../../actions/store';

const useTemplateLoader = () => {
  const [options, setOptions] = useState({ execute: false });

  const dispatch = useDispatch();

  const load = () => {
    dispatch(dataCompletedAction({ slice: 'Preloaded', path: 'templates' }));
    return onSnapshot(
      collection(db, 'templates'),
      querySnapshot => {
        const items = [];

        querySnapshot.forEach(doc => {
          const dataItem = doc.data();
          dataItem.id = doc.id;
          items.push(dataItem);
        });

        dispatch(templatesLoadedAction(items));
      },
      error => {
        console.error('useTemplateLoader.onSnapshot', error);
      }
    );
  };

  useEffect(() => {
    let unSub = () => {};
    if (options.execute) {
      unSub = load();
    }
    return () => {
      unSub();
    };
  }, [options]);

  return {
    loadTemplates: (options = {}) => {
      setOptions({ ...options, execute: true });
    }
  };
};

export default useTemplateLoader;
